export const GET_LAST_DEADLINE_DATES_REQUEST = 'GET_LAST_DEADLINE_DATES_REQUEST';

export const getLastDeadlineDatesRequest = ( proceeding ) => ({
    type: GET_LAST_DEADLINE_DATES_REQUEST,
    payload: { proceeding }
});
